import { createRowId } from '~/utils/societePayloadBuilder/ids';

import { createPromoDraftLabel } from '../promos';

import type { LuxPlusPromoBanner, LuxPlusPromoBannerCarouselState } from './types';

export function createDefaultPromoBanner(
  draftLabel = createPromoDraftLabel(0),
  overrides: Partial<Omit<LuxPlusPromoBanner, 'draftId' | 'draftLabel'>> = {},
): LuxPlusPromoBanner {
  return {
    draftId: createRowId(),
    draftLabel,
    label: '',
    title: '',
    ctaText: '',
    ctaLink: '',
    ctaLinkType: 'link',
    expiresAt: '',
    eligibleRegions: ['AU'],
    ...overrides,
  };
}

export function createDefaultPromoBannerCarouselState(): LuxPlusPromoBannerCarouselState {
  return {
    mode: 'promoBannerCarousel',
    promos: [createDefaultPromoBanner()],
  };
}
